import React from "react";
import classnames from "classnames";
import map from "lodash/map";

import { licenses, licensesDisplay, constToCSS } from "../../reducers/download";
import LicenseDisplay from "./license-display";

export default props => {
    let { download } = props;

    let { license, iconBaseLicense } = download;

    let canAdvance = !!license;

    let buttonColor =
        license && license == licenses.ROYALTY_FREE ? "blue" : "green";
    let buttonClass = classnames("button", {
        [buttonColor]: canAdvance,
        disabled: !canAdvance
    });

    let licenseChoices = [];

    licenseChoices.push(
        <LicenseDisplay
            key={licenses.ROYALTY_FREE}
            license={licenses.ROYALTY_FREE}
            current={license}
            onSelect={props.downloadSelectLicense}
        />
    );

    if (iconBaseLicense != licenses.PUBLIC_DOMAIN) {
        licenseChoices.push(
            <LicenseDisplay
                key={licenses.CREATIVE_COMMONS}
                license={licenses.CREATIVE_COMMONS}
                current={license}
                onSelect={props.downloadSelectLicense}
            />
        );
    } else {
        licenseChoices.push(
            <LicenseDisplay
                key={licenses.PUBLIC_DOMAIN}
                license={licenses.PUBLIC_DOMAIN}
                current={license}
                onSelect={props.downloadSelectLicense}
            />
        );
    }

    let classes = classnames({
        "license-selected": !!license
    });

    return (
        <div className={classes}>
            <ul className="license-choices bubble-choices">{licenseChoices}</ul>
            <button
                className={buttonClass}
                onClick={props.downloadCommitLicense}
            >
                Continue
            </button>
        </div>
    );
};
